import React from "react";

const Spinner = ({ size = "medium", color = "primary", fullPage = false }) => {
  // Keep props + behavior identical, only UI classes changed
  const sizeMap = {
    small: "h-5 w-5 border-2",
    medium: "h-8 w-8 border-2",
    large: "h-12 w-12 border-[3px]",
  };

  // "color" prop mapping (primary/default fits AJMM medical blue palette)
  const colorMap = {
    primary:
      "border-sky-200 border-t-sky-600 dark:border-sky-900/50 dark:border-t-sky-400",
    secondary:
      "border-slate-200 border-t-slate-700 dark:border-slate-800 dark:border-t-slate-200",
    success:
      "border-emerald-200 border-t-emerald-600 dark:border-emerald-900/50 dark:border-t-emerald-400",
    warning:
      "border-amber-200 border-t-amber-600 dark:border-amber-900/50 dark:border-t-amber-400",
    danger:
      "border-rose-200 border-t-rose-600 dark:border-rose-900/50 dark:border-t-rose-400",
    info:
      "border-cyan-200 border-t-cyan-600 dark:border-cyan-900/50 dark:border-t-cyan-400",
    note:
      "border-indigo-200 border-t-indigo-600 dark:border-indigo-900/50 dark:border-t-indigo-400",
  };

  const ringSize = sizeMap[size] || sizeMap.medium;
  const ringColor = colorMap[color] || colorMap.primary;

  if (fullPage) {
    return (
      <div className="pt-20">
        <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-7xl items-center justify-center px-4">
          <div className="flex flex-col items-center gap-3">
            <div
              className={[
                "animate-spin rounded-full",
                ringSize,
                "border-solid",
                ringColor,
              ].join(" ")}
              aria-label="Loading"
              role="status"
            />
            <p className="text-sm font-medium text-slate-600 dark:text-slate-300">
              Loading...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center justify-center" aria-label="Loading" role="status" style={{width: "100%"}}>
      <div
        className={[
          "animate-spin rounded-full",
          ringSize,
          "border-solid",
          ringColor,
        ].join(" ")}
      />
    </div>
  );
};

export default Spinner;
